/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { regexSearch } from '../util'
import Collection from './collection'
import Group from './group'
import _ from 'underscore'

const remainingUnsortedGroups = (self, groups) =>
  self.filter(function (missingGroup) {
    if (missingGroup.id !== Group.defaultId) {
      return _.find(groups, group => group.id === missingGroup.id) === undefined
    } else {
      return false
    }
  })

const nextNext = function (self, group) {
  let nextGroup = group
  for (let i = 0; i <= 2; i++) {
    if (nextGroup) {
      const nextId = nextGroup.get('next_group_id')
      nextGroup = self.get(nextId)
    }
  }

  return nextGroup
}

/*
 * This function sets a sequence attribute with an integer
 * and does not sort the collection
 */
const setSequence = function (self) {
  let groups = []

  // get the next_group_id attributes from the real groups
  const nextGroupIds = []
  self.each(function (g) { if (g.isRealGroup()) { return nextGroupIds.push(g.get('next_group_id')) } })

  // Only sort if we have a list and there are no duplicate next_group_id values
  if (nextGroupIds.length > 0) {
    let circularSafeguard, head
    const tailIndex = _.indexOf(nextGroupIds, null)

    if (tailIndex === -1) {
      // In this case we don't know our index
      head = self.find(group => group.id !== Group.defaultId)
    } else {
      // Set next group to the first group that is not "Ungrouped"
      head = self.find(group => (group.id !== Group.defaultId) && (_.indexOf(nextGroupIds, group.id) === -1))
    }

    let nextGroup = (circularSafeguard = head)

    while (nextGroup) {
      circularSafeguard = nextNext(self, circularSafeguard)

      const currentGroup = nextGroup
      groups.push(currentGroup)

      const nextId = currentGroup.get('next_group_id')
      nextGroup = self.get(nextId)
      if (nextGroup === undefined) {
        // a bad nextgroup was set, we can't continue sorting
        break
      }

      if (nextId === null) {
        // loop in group ordering
        break
      }

      // if the circular reference includes all groups we can short circuit using head
      const correctHeadShortCircuit = nextId === head.id
      // if the circular reference exists in a subset of the groups use safegaurd
      const safeguardTriggered = (circularSafeguard != null ? circularSafeguard.id : undefined) === nextGroup.id

      if (correctHeadShortCircuit || safeguardTriggered) {
        // we can't continue sorting
        break
      }
    }
  }

  // splice the remaining groups to the top of our list
  groups.splice.apply(groups, ([0, 0]).concat(remainingUnsortedGroups(self, groups).reverse()))

  // put the ungrouped group at the top
  groups.splice(0, 0, self.ungrouped())
  groups = _.compact(groups)

  // set the sequence according to the order in the array
  groups.forEach((group, index) =>
    group.set(
      { sequence: index }
      , { silent: true })
  )

  return groups
}

/*
 * This is a collection of groups which is sequenced via a linked-list.
 * By default Backbone will sort by group id.
 * To order by linked-list, set the comparator to "sequence". That said,
 * the "sequence" is [Ungrouped] first then followed by the linked list. Newly
 * created groups are always at the top of the linked list. If there is a broken link
 * or a circuler dependency, all the remaining groups will be appended the top of the list
 * after [Ungrouped]. And when a new group is created, the backend will point the new group
 * to the last broken link.
 */
export default class Groups extends Collection {
  get model () { return Group }
  get url () { return '/api/groups' }
  get states () { return {} }

  /*
   * Overrides the Backbone#sort method
   * If the @comparator == "sequence", the sequence attribute will
   * be set on each model based on the linked list
   *
   */
  sort () {
    /*
     * if the comparator is sequence, then we need to populate the
     * sequence first
     */
    if (this.comparator === 'sequence') { setSequence(this) }
    return super.sort(...arguments)
  }

  /*
   * Defaults to group.id
   *
   */
  comparator (group) {
    return group.id
  }

  checked () {
    return this.where({ checked: true })
  }

  checkedPolls () {
    return this.reduce(function (selected, group) {
      group.polls().each(function (poll) {
        if (poll.get('checked')) { return selected.push(poll) }
      })

      return selected
    }
    , [])
  }

  clearChecked () {
    return this.each(function (group) {
      group.set({
        checked: false,
        indeterminate: false
      })

      return group.polls().each(poll => poll.set({ checked: false }))
    })
  }

  ungrouped () {
    return this.get(Group.defaultId)
  }

  search (term) {
    const regex = regexSearch(term)

    return this.filter(group => regex.test(group.get('name')))
  }

  fetch (opts) {
    if (opts == null) { opts = {} }
    if (opts.data == null) { opts.data = {} }
    return super.fetch(opts)
  }

  fetchWithPolls () {
    return this.fetch({
      data: {
        include_polls: true
      }
    }).then(() => {
      return this.invoke('markAsLoaded')
    })
  }

  /*
   * TODO: Move group sorting into server side API
   * This public method is deprecated and currently remains for backwards compatibility.
   * @return [Array] Group models
   * @deprecated
   *
   */
  sortGroups () {
    return setSequence(this)
  }
}
